import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FullSpinner } from "@/components/States";

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/analytics/funnel").then(({ data }) => setD(data)); }, []);
  if (!d) return <FullSpinner label="Loading analytics…" />;
  const max = Math.max(...d.stages.map((s) => s.count), 1);
  return (
    <div className="space-y-6" data-testid="admin-analytics">
      <h1 className="font-serif text-3xl font-bold">Engagement Funnel</h1>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {[["DAU", d.activity.dau], ["WAU", d.activity.wau], ["MAU", d.activity.mau], ["DAU/MAU", `${d.activity.dau_mau_ratio}%`]].map(([l, v]) => (
          <div key={l} className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-4">
            <div className="font-serif text-2xl font-bold text-[#E2C382]">{v}</div>
            <div className="text-xs text-[#D8B4B9]">{l}</div>
          </div>
        ))}
      </div>

      <div className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-5 space-y-3">
        <h2 className="font-serif text-lg font-semibold">Registration → Found Match drop-off</h2>
        {d.stages.map((s, i) => (
          <div key={s.stage} data-testid={`funnel-stage-${i}`}>
            <div className="flex items-center justify-between text-sm mb-1">
              <span className="text-[#FAF5F0]">{s.stage}</span>
              <span className="text-[#D8B4B9]">{s.count} · {s.of_top_pct}% of top{i > 0 ? ` · ${s.from_prev_pct}% from prev` : ""}</span>
            </div>
            <div className="h-6 bg-[#1A090D] rounded-lg overflow-hidden">
              <div className="h-full bg-gradient-to-r from-[#781826] to-[#C59B27] rounded-lg flex items-center px-2 text-[11px] text-white font-medium"
                style={{ width: `${Math.max(4, (s.count / max) * 100)}%` }}>
                {i > 0 && s.drop_off > 0 ? `−${s.drop_off} dropped` : ""}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-5">
        <h2 className="font-serif text-lg font-semibold mb-3">User Lifecycle</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {Object.entries(d.lifecycle).map(([k, v]) => (
            <div key={k} className="bg-[#1A090D] rounded-xl p-3">
              <div className="font-serif text-xl font-bold text-[#E2C382]">{v}</div>
              <div className="text-[11px] text-[#D8B4B9] capitalize">{k.replace(/_/g, " ").toLowerCase()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
